import { PageWrapper, Tabs } from '@welbe/web-design-system';
import File from 'App/assets/img/file.svg?url';
import HeartBalloon from 'App/assets/img/heart-balloon.svg?url';
import Letter from 'App/assets/img/letter.svg?url';
import Result from 'App/assets/img/result.svg?url';
import { PageBox } from 'App/Components/PageBox/PageBox';
import { PageBoxHeader } from 'App/Components/PageBox/PageBoxHeader';
import { Fragment, useMemo, useState } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { CampaignProvider } from './Campaign.context';
import { Collaborators } from './Tabs/Collaborators/Collaborators';
import { CollaboratorProvider } from './Tabs/Collaborators/context/CollaboratorContext';
import { Communications } from './Tabs/Communications/Communications';
import { Evaluations } from './Tabs/Evaluations/Evaluations';
import { Results } from './Tabs/Results/Results';

export const Campaign = (): JSX.Element => {
	const [isCommunicationsEmpty, setCommunicationsEmpty] = useState(false);
	const location = useLocation();
	const navigate = useNavigate();
	const params = new URLSearchParams(window.location.search);
	const token = params.get('campaignName');
	let title = '';
	const [active, setActive] = useState<number>(0);
	if (token) title = window.atob(token);

	const tabs = [
		{
			name: 'Comunicación',
		},
		{
			name: 'Monitoreo',
		},
		{
			name: 'Resultados',
		},
		{
			name: 'Colaboradores',
		},
	];

	const handleChangeActiveTab = (tab: number) => {
		setActive(tab);
	};

	const components = useMemo(
		() => [
			{
				id: 0,
				content: (
					<PageBox>
						<PageBoxHeader icon={Letter} title={title} />
						<Communications
							onFetchCommunications={(value) => setCommunicationsEmpty(!value)}
						/>
					</PageBox>
				),
			},
			{
				id: 1,
				content: (
					<PageBox>
						<PageBoxHeader icon={File} title={title} />
						<Evaluations
							isCommunicationsEmpty={isCommunicationsEmpty}
							onChangeToResults={() => setActive(2)}
						/>
					</PageBox>
				),
			},
			{
				id: 2,
				content: (
					<PageBox>
						<PageBoxHeader icon={Result} title={title} />
						<Results onChangeInitialTab={handleChangeActiveTab} />,
					</PageBox>
				),
			},
			{
				id: 3,
				content: (
					<PageBox>
						<PageBoxHeader icon={HeartBalloon} title={title} />
						<CollaboratorProvider>
							<Collaborators />
						</CollaboratorProvider>
					</PageBox>
				),
			},
		],
		// eslint-disable-next-line react-hooks/exhaustive-deps
		[active],
	);

	const onChangeTab = (tabNumber: number) => {
		setActive(tabNumber);
		tabNumber !== 3 && navigate(location.pathname.concat(location.search));
	};

	return (
		<PageWrapper>
			<CampaignProvider>
				<Fragment>
					<Tabs
						initialActiveTab={active}
						side="right"
						tabItems={tabs}
						onChange={onChangeTab}
						height="100%"
						width="100%"
						overflow="hidden"
						className="tabs-container"
					/>
					{components[active].content}
				</Fragment>
			</CampaignProvider>
		</PageWrapper>
	);
};
